import React from 'react';
import { LogoSVG, OldLogoSVG } from './style';

function Logo(props) {
  return props.old ? <OldLogoSVG {...props} /> : <LogoSVG {...props} />;
}

export default Logo;
